var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 148,
    viewBox: "0 0 125 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12633_225832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 20,
    width: 76,
    height: 100,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 20.5,
    width: 75,
    height: 99,
    rx: 3.5,
    stroke: "#F5F6F7",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12633_225832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0833 42.6693H57.4167C57.2399 42.6693 57.0703 42.599 56.9453 42.474C56.8202 42.349 56.75 42.1794 56.75 42.0026V30.0026C56.75 29.8258 56.8202 29.6562 56.9453 29.5312C57.0703 29.4062 57.2399 29.3359 57.4167 29.3359H68.0833C68.2601 29.3359 68.4297 29.4062 68.5547 29.5312C68.6798 29.6562 68.75 29.8258 68.75 30.0026V42.0026C68.75 42.1794 68.6798 42.349 68.5547 42.474C68.4297 42.599 68.2601 42.6693 68.0833 42.6693ZM60.0833 32.6693V34.0026H65.4167V32.6693H60.0833ZM60.0833 35.3359V36.6693H65.4167V35.3359H60.0833ZM60.0833 38.0026V39.3359H65.4167V38.0026H60.0833Z",
    fill: "#FFC107"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.25,
    y: 48,
    width: 39,
    height: 8,
    rx: 1,
    fill: "#EBEDF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.75,
    y: 62,
    width: 60,
    height: 8,
    rx: 1,
    fill: "#EBEDF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.75,
    y: 76,
    width: 60,
    height: 8,
    rx: 1,
    fill: "#EBEDF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.75,
    y: 90,
    width: 60,
    height: 8,
    rx: 1,
    fill: "#EBEDF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.75,
    y: 104,
    width: 60,
    height: 8,
    rx: 1,
    fill: "#EBEDF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12633_225832",
    x: 0.75,
    y: 0,
    width: 124,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12633_225832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12633_225832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12633_225832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(54.75 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostDocument);
export default __webpack_public_path__ + "static/media/PostDocument.c557dc4d9d90551bd2e5c9f0d70770ac.svg";
export { ForwardRef as ReactComponent };